import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const SrvSecManager = () => {
  const [services, setServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/srv_sec"; // Base URL para SGVMAP_SRV_SECController

  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }

  // Obtener la lista de servicios
  const fetchServices = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: {
          'Authorization': getAuthorization()
        }
      }); // Asume que hay un endpoint para obtener todos los servicios
      if (!response.ok) throw new Error("Error al obtener los servicios");
      const data = await response.json();
      setServices(data);
    } catch (error) {
      message.error("Error al obtener la lista de servicios");
      console.error(error);
    }
  };

  // Crear o actualizar un servicio
  const handleSaveService = async (values) => {
    const method = editingService ? "PUT" : "POST";
    const url = editingService
      ? `${baseURL}/update/${editingService.idSrvSec}`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json", 'Authorization': getAuthorization() },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar el servicio");

      message.success(
        editingService
          ? "Servicio actualizado correctamente"
          : "Servicio creado correctamente"
      );
      fetchServices();
      setIsModalOpen(false);
      setEditingService(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar el servicio");
      console.error(error);
    }
  };

  // Eliminar un servicio
  const handleDeleteService = async (idSrvSec) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idSrvSec}`, {
        method: "DELETE", headers: {
          'Authorization': getAuthorization()
        }

      });
      if (!response.ok) throw new Error("Error al eliminar el servicio");

      message.success("Servicio eliminado correctamente");
      fetchServices();
    } catch (error) {
      message.error("Error al eliminar el servicio");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (service) => {
    setEditingService(service);
    form.setFieldsValue(service);
    setIsModalOpen(true);
  };

  // Abrir modal para crear
  const handleCreate = () => {
    setEditingService(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const columns = [
    {
      title: "ID Servicio",
      dataIndex: "idSrvSec",
      key: "idSrvSec",
    },
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este servicio?"
            onConfirm={() => handleDeleteService(record.idSrvSec)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Servicios de Seguridad</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Servicio
      </Button>
      <Table columns={columns} dataSource={services} rowKey="idSrvSec" />

      <Modal
        title={editingService ? "Editar Servicio" : "Crear Servicio"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveService}
          initialValues={{ username: "", password: "" }}
        >

          <Form.Item
            name="idSrvSec"
            label="ID Servicio"
            rules={[{ required: true, message: "Por favor, ingrese un ID Servicio" }]}
          >
            <Input placeholder="ID Servicio" />
          </Form.Item>
          <Form.Item
            name="username"
            label="Usuario"
            rules={[{ required: true, message: "Por favor, ingrese un usuario" }]}
          >
            <Input placeholder="Nombre de Usuario" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Contraseña"
            rules={[{ required: true, message: "Por favor, ingrese una contraseña" }]}
          >
            <Input.Password placeholder="Contraseña" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SrvSecManager;
